import React from 'react';
import { SkeletonParagraph } from './skeleton-paragraph';

export const SkeletonMedia: React.FC<SkeletonProps> = props => {
  return (
    <SkeletonParagraph
      circle={props.circle}
      height={props.height}
      width={props.width}
      flex
    />
  );
};

interface SkeletonProps {
  circle?: boolean;
  height?: string | number;
  width?: string | number;
}
